import { PropsWithChildren } from 'react';

type ErrorMessageProps = {
    className?: string;
};

const ErrorMessage = ({
    className,
    children,
}: PropsWithChildren<ErrorMessageProps>) => {
    return (
        <div className={`text-red-600 text-sm ${className}`}>{children}</div>
    );
};

export default ErrorMessage;
